import { useAppContext } from "./ContextProvider";

/**
 * A kiválasztott liga+torna, nem-null típussal. Csak <RequireContext>-en belül
 * használd (az garantálja, hogy mindkettő be van állítva).
 */
export function useScope(): { leagueId: string; tournamentId: string } {
  const { leagueId, tournamentId } = useAppContext();
  return { leagueId: leagueId as string, tournamentId: tournamentId as string };
}
